export default "__VITE_ASSET__CQxPubot__"